import React, { useState, useEffect } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Modal from "react-responsive-modal";
import { get_promotion_prize } from "../../../../utils";
import { adcard_actions } from "../../../../redux-store";
import { Helmet } from "react-helmet";
import ReactPaginate from "react-paginate";
import { formatPrice } from "../../../../utils/formatPrice";
import ClipLoader from "react-spinners/ClipLoader";

const Orders = () => {
  const history = useHistory();
  const { pathname } = useLocation();

  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { data: adcards, totalPages } = useSelector((state) => state.adcard);

  const [deactivate, setDeactivate] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const deactivate_handler = () => {
    const update = {
      _id: deactivate.card_id,
      isActive: false,
      status: "Inactive",
    };
    setDeactivate(null);
    dispatch(adcard_actions.update_adcard(update)).then(() => {
      dispatch(
        adcard_actions.fetch_adcard({
          member_user: user.user._id,
          page: currentPage,
          limit: 5,
        })
      );
    });
  };

  const activate_handler = (card) => {
    const update = {
      _id: card._id,
      isActive: true,
      status: "Active",
    };

    dispatch(adcard_actions.update_adcard(update)).then(() => {
      dispatch(
        adcard_actions.fetch_adcard({
          member_user: user.user._id,
          page: currentPage,
          limit: 5,
        })
      );
    });
  };

  useEffect(() => {
    if (user) {
      if (!pathname.includes(user?.user?.role)) {
        history.replace(`/dashboard/${user?.user?.role}`);
      }
    }
  }, [user, pathname, history]);

  useEffect(() => {
    if (user && currentPage) {
      setLoading(true);
      dispatch(
        adcard_actions.fetch_adcard({
          member_user: user.user._id,
          page: currentPage,
          limit: 5,
        })
      ).finally(() => {
        setLoading(false);
      });
    }
  }, [dispatch, user, currentPage]);

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1); // ReactPaginate uses zero-based indexing
  };

  const getStatusLabel = (status) => {
    const badgeStyle = {
      fontSize: "0.8rem",
      padding: "0.3rem 0.5rem",
    };

    switch (status) {
      case "Active":
        return (
          <span className="badge badge-success" style={badgeStyle}>
            Active
          </span>
        );
      case "Expired":
        return (
          <span className="badge badge-danger" style={badgeStyle}>
            Expired
          </span>
        );
      case "Inactive":
        return (
          <span className="badge badge-secondary" style={badgeStyle}>
            Inactive
          </span>
        );
      default:
        return (
          <span className="badge badge-light" style={badgeStyle}>
            Unknown
          </span>
        );
    }
  };

  return (
    <>
      <Helmet>
        <title>eksplode! | My EACs</title>
      </Helmet>
      <div className="dashboard">
        <div className="page-title">
          <h2>My EACs</h2>
        </div>
        {loading ? (
          <div className="py-5 d-flex justify-content-center w-100">
            <ClipLoader color={"#000000"} loading={loading} size={60} />
          </div>
        ) : adcards && adcards.length > 0 ? (
          <>
            {adcards.map((card) => {
              const expired = card.status === "Expired";
              return (
                <div className="box-account box-info mt-3" key={card._id}>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="box">
                        <div className="box-title d-flex justify-content-between">
                          <div>
                            <h3>
                              <span>{card?.product?.product_name}</span>
                              <br />
                              <small className="text-muted">
                                Promotion Prize &mdash; 
                                {formatPrice(get_promotion_prize(card.product))} / Item
                              </small>
                              <br />
                              <small className="text-muted">
                                Date Created:{" "}
                                {new Date(card.sharedlink_date).toDateString()}
                              </small>
                              <br />
                              <small className="text-muted">
                                Ad Card Expiry:{" "}
                                {new Date(card.expiry_date).toDateString()}
                              </small>
                            </h3>
                          </div>
                          <div>{getStatusLabel(card.status)}</div>
                        </div>
                        <div className="box-content">
                          <h4>Orders Placed &mdash; {card.noOfOrders || 0}</h4>
                        </div>
                        <div className="box-content d-flex justify-content-between">
                          {card.status === "Active" && (
                            <>
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setDeactivate({
                                    product_name: card.product.product_name,
                                    card_id: card._id,
                                  });
                                }}
                              >
                                Deactivate
                              </a>
                              <span>
                                <Link to={`/adcard/${card?._id}`}>
                                  View Ad Card
                                </Link>
                                <Link
                                  className="ml-2"
                                  to={`/product/${card?.product?._id}`}
                                >
                                  View Product
                                </Link>
                              </span>
                            </>
                          )}
                          {(expired || card.status === "Inactive") && (
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                activate_handler(card);
                              }}
                            >
                              Activate
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
              );
            })}
            <div className="d-flex justify-content-center mt-5">
              <ReactPaginate
                previousLabel={"<<"}
                nextLabel={">>"}
                breakLabel={"..."}
                pageCount={totalPages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageChange}
                containerClassName={"pagination"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active"}
                forcePage={currentPage - 1}
              />
            </div>
          </>
        ) : (
          <div className="box-account box-info mt-3">
            <div className="my-5 row justify-content-center">
              <h3>Nothing Available</h3>
            </div>
          </div>
        )}
        <Modal open={!!deactivate} onClose={() => setDeactivate(null)} center>
          {deactivate && (
            <div className="container px-5 pt-5">
              <div className="row">
                <p>
                  Are you sure you want to deactivate the promotion for{" "}
                  <strong>{deactivate.product_name}</strong>?
                </p>
              </div>
              <div className="row mt-3 justify-content-center">
                <button className="btn btn-solid" onClick={deactivate_handler}>
                  Confirm
                </button>
              </div>
            </div>
          )}
        </Modal>
      </div>
    </>
  );
};

export default Orders;
